import React, { Component } from "react";
import {
	View,
	Text,
	StyleSheet,
	KeyboardAvoidingView,
	Platform,
	WebView,
} from "react-native";

import { Dropdown } from "components/third-party/Dropdown";
import RNPickerSelect from "components/third-party/react-native-picker-select";

import * as x from "../../styles/css";

class Select extends Component {
	render() {
		return (
			<View>
				{Platform.OS === "web" ? (
					<View style={{ marginBottom: 20}} >
						<Text
							style={{
								color: "gray",
								marginBottom: 10,
							}}
						>
							{this.props.label}
						</Text>
						<View
							style={{
								borderRadius: 1,
								borderWidth: this.props.error ? 2 : 1,
								borderColor: this.props.error
									? x.colors.error
									: "rgba(0,0,0,0.2)",
							}}
						>
							<select
								value={this.props.value}
								onChange={this.props.onChange}
								style={{
									height: 40,
									fontSize: 14,
									appearance: "none",
									lineHeight: 1,
									outline: 0,
									color: "black",
									borderWidth: 0,
									backgroundColor: "white",
									padding: 5,
									marginTop: "auto",
									marginBottom: "auto",
								}}
							>
								{this.props.data.map(val => {
									return <option>{val}</option>;
								})}
							</select>
						</View>
					</View>
				) : (
					<View>
						{this.props.native ? (
							<RNPickerSelect 
								onValueChange={this.props.onChangeText}
								label={this.props.label}
								value={this.props.value}
								items={this.props.data.map(val => {
									return { label: `${val}`, value: `${val}` };
								})}
							/>
						) : (
							<Dropdown
								label={this.props.label}
								onChangeText={this.props.onChangeText}
								value={this.props.value}
								error={this.props.error}
								data={this.props.data.map(val => {
									return { value: `${val}` };
								})}
							/>
						)}
					</View>
				)}
			</View>
		);
	}
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select/index.js